export default __webpack_public_path__ + "static/media/pizzaleimg.288f3585.png";